import { LuCheck } from 'react-icons/lu'
import { GrainOverlay } from '@/components/ui/GrainOverlay'
import { Reveal } from '@/components/ui/Reveal'
import { recognitions } from '@/data/about'

export const AboutPullQuote = () => (
  <section className="relative overflow-hidden bg-green-950 py-16 text-base-50 sm:py-20 lg:py-24">
    <GrainOverlay opacity={0.025} />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-40 -top-40 h-[480px] w-[480px] rounded-full bg-green-800/20 blur-3xl"
    />
    <div className="relative z-10 mx-auto max-w-6xl px-6">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <blockquote className="mb-6 font-display text-2xl leading-snug tracking-tight sm:text-3xl">
            “My mission has always been to change the <span className="text-gold-200">mindset</span>{' '}
            around health, empowering people to reconnect with nature, understand themselves as a
            whole, and take a conscious, informed role in their own health and wellbeing.”
          </blockquote>
          <p className="text-sm text-green-200">Kandake Makonnen · Founder, Instrumental Health</p>
        </Reveal>

        <Reveal delay={120}>
          <h3 className="mb-6 font-display text-xl">Recognitions &amp; affiliations</h3>
          <ul className="space-y-3">
            {recognitions.map((r) => (
              <li
                key={r.label}
                className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-4 transition-colors hover:border-gold-200/40"
              >
                <span
                  aria-hidden="true"
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold-400/15 text-gold-200"
                >
                  <LuCheck className="h-4 w-4" />
                </span>
                <div>
                  <p className="text-sm font-medium text-base-50">{r.label}</p>
                  <p className="text-sm text-green-200">{r.sub}</p>
                </div>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
)
